import type { ReactNode } from 'react'
import AdSlot from '@/components/AdSlot'
import Footer from '@/components/Footer'
import Header from '@/components/Header'

interface LayoutProps {
  children: ReactNode
}

function Layout({ children }: LayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-slate-950 text-slate-50">
      <AdSlot variant="leaderboard" />
      <Header />
      <main className="flex-1 pb-16 sm:pb-0">{children}</main>
      <Footer />
      <AdSlot variant="sticky" />
    </div>
  )
}

export default Layout
